var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll--container"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"scroll--card"},[_c('dashboard-summary-status-card',{attrs:{"item":item,"disabled":item.disabled}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }